<template>
    <div
        v-if="isActive"
        v-bind:class="this.isBlurred ? getOuterDivClass : getClass"
        v-bind:style="this.isBlurred ? getOuterDivStyle : getDivStyle"
        :data-width="getImageWidth"
        :data-height="getImageHeight"
        :data-thumbnail="generateMediaUrl({ id: data.id, w: 300, h: 175 })"
        :role="!isImgActive ? 'img' : null"
        :aria-label="!isImgActive ? getAltTag : null"
        :data-copyright="getCopyrightTag ? getCopyrightTag : null"
    >
        <img
            v-if="isImgActive"
            v-bind:src="getImgSrc"
            v-bind:style="getImgStyle"
            v-bind:alt="getAltTag"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl', 'getFileById']),
        getArgs() {
            let args = null,
                data = null;
            if (
                this.dataSource !== undefined &&
                this.dataSource !== null &&
                this.dataSource !== ''
            ) {
                data = this.getProp(this.dataSource);
            }
            if (this.data !== undefined && this.data !== null && this.data !== '') {
                data = this.data;
            }
            if (data && data.id) {
                args = {};
                args['id'] = data.id;
                if (this.width) {
                    args['w'] = this.width;
                }
                if (this.height) {
                    args['h'] = this.height;
                }
                if (data.position_x) {
                    args['position_x'] = data.position_x;
                }
                if (data.position_y) {
                    args['position_y'] = data.position_y;
                }
                if (data.transparency) {
                    args['opacity'] = parseFloat(100 - parseInt(data.transparency)) / 100;
                }
                if (data.background_size) {
                    args['background_size'] = data.background_size;
                }
                let file = this.getFileById(data.id);
                if (
                    file !== undefined &&
                    file !== null &&
                    file !== '' &&
                    'alt' in file &&
                    file.alt != '' &&
                    file.alt != null
                ) {
                    args['alt'] = file.alt;
                } else if (this.altTag) {
                    args['alt'] = this.altTag;
                }
                if (
                    file !== undefined &&
                    file !== null &&
                    file !== '' &&
                    'copyright' in file &&
                    file.copyright != ''
                ) {
                    args['copyright'] = file.copyright;
                }
                if (
                    file !== undefined &&
                    file !== null &&
                    file !== '' &&
                    'image_width' in file &&
                    file.image_width != ''
                ) {
                    args['image_width'] = file.image_width;
                }
                if (
                    file !== undefined &&
                    file !== null &&
                    file !== '' &&
                    'image_height' in file &&
                    file.image_height != ''
                ) {
                    args['image_height'] = file.image_height;
                }
                return args;
            }
            if (
                (this.path !== undefined && this.path !== null && this.path !== '') ||
                (this.placeholder !== undefined &&
                    this.placeholder !== null &&
                    this.placeholder !== '')
            ) {
                args = {};
                args['path'] = this.path || this.placeholder;
                if (this.width) {
                    args['w'] = this.width;
                }
                if (this.height) {
                    args['h'] = this.height;
                }
                return args;
            }
            return null;
        },
        isActive() {
            return this.getArgs !== null;
        },
        isImgActive() {
            if (this.tag !== 'img') {
                return false;
            }
            return this.isActive;
        },
        getClass() {
            let str = 'image-container image-container--' + this.tag;
            if (this.customClass) {
                str += ' ' + this.customClass;
            }
            return str;
        },
        getOuterDivClass() {
            let str = this.getClass;
            str += ' bg--blur';
            return str;
        },
        getDivStyle() {
            let style = {},
                args = this.getArgs;
            if (this.tag !== 'div' && !this.imgOpacity) {
                return null;
            }
            if (this.imgOpacity) {
                if (args.opacity == '0' || args.opacity > 0) {
                    style['opacity'] = args.opacity;
                }
                return style;
            }
            style['backgroundImage'] = 'url(' + this.generateMediaUrl(args) + ')';
            if (args.position_x) {
                style['backgroundPositionX'] = args.position_x;
            }
            if (args.position_y) {
                style['backgroundPositionY'] = args.position_y;
            }
            if (args.opacity == '0' || args.opacity > 0) {
                style['opacity'] = args.opacity;
            }
            if (args.background_size) {
                style['backgroundSize'] = args.background_size;
            }
            return style;
        },
        getOuterDivStyle() {
            let style = {},
                args = this.getArgs;
            if (this.tag !== 'div' && !this.imgOpacity) {
                return null;
            }
            style['backgroundImage'] = 'url(' + this.generateMediaUrl(args) + ')';
            if (args.opacity == '0' || args.opacity > 0) {
                style['opacity'] = args.opacity;
            }
            return style;
        },
        getImgStyle() {
            return {};
        },
        getImgSrc() {
            let src = '',
                args = this.getArgs;
            src = this.generateMediaUrl(args);
            return src;
        },
        getImageWidth() {
            let args = this.getArgs;
            if ('image_width' in args) {
                return args.image_width;
            }
            return '';
        },
        getImageHeight() {
            let args = this.getArgs;
            if ('image_height' in args) {
                return args.image_height;
            }
            return '';
        },
        getAltTag() {
            let args = this.getArgs;
            if ('alt' in args) {
                return args.alt;
            }
            return '';
        },
        getCopyrightTag() {
            let args = this.getArgs;
            if ('copyright' in args) {
                return args.copyright;
            }
            return '';
        }
    },
    created() {},
    mounted() {},
    props: {
        dataSource: String,
        data: Object,
        path: String,
        placeholder: String,
        width: Number,
        height: Number,
        tag: String,
        showDivInner: Boolean,
        imgOpacity: Boolean,
        customClass: String,
        altTag: String,
        isBlurred: Boolean
    }
};
</script>
